import { useEnv } from "@/contexts/cdpConfig";
import { usePlatoAvailable, usePlatoSettings } from "@/contexts/contact";
import { useEffect, useRef } from "react";
import { platoUrls } from "../constants";
import { getFeaturesEnabled } from "@/utils";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
/**
 * This Hook will load the Plato Widget if it is enabled
 * Loading will occur after the BFF call since the platoSettings are required
 */
export const useLoadPlato = () => {
    const { language } = useLocale();
    const scriptsLoaded = useRef(false);
    const env = useEnv();
    // Plato feature is "enabled" for the current Brand
    const { plato } = getFeaturesEnabled();
    // Plato is "availaible" for the current Agency / Classified
    const platoAvailable = usePlatoAvailable();
    // platoSettings are provided by the BFF
    const platoSettings = usePlatoSettings();
    useEffect(() => {
        if (plato && platoAvailable && !scriptsLoaded.current && platoSettings) {
            const platoWidgetScript = document.createElement("script");
            platoWidgetScript.src = platoUrls[env];
            const platoSettingsScript = document.createElement("script");
            platoSettingsScript.innerHTML = `window.platoSettings = {
        source: "${platoSettings === null || platoSettings === void 0 ? void 0 : platoSettings.source}",
        reference: "${platoSettings === null || platoSettings === void 0 ? void 0 : platoSettings.reference}",
        agencyId: "${platoSettings === null || platoSettings === void 0 ? void 0 : platoSettings.agencyId}",
        locale: "${language}",
        }
        `;
            platoWidgetScript.id = "plato.widget";
            platoSettingsScript.id = "plato.settings";
            platoWidgetScript.async = true;
            platoSettingsScript.async = true;
            // Settings shoulb be set before the Widget is Loaded
            document.head.appendChild(platoSettingsScript);
            document.head.appendChild(platoWidgetScript);
            scriptsLoaded.current = true;
        }
    }, [platoSettings, language, plato, env, platoAvailable]);
};
